import React from 'react'

// REFACTOR: refactor code base to use this component
export default props => <b style={{ color: '#604f93' }}>{props.data}</b>
